// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3-ripRKXCf wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/public/ReferAuthorizedUser/ReferAuthorizedUser.module.less
// module id = 964
// module chunks = 3